import { selectSelectedPricingPlan } from '../../../../../store/workspace/selectors';
import { applyReferralCodeThunk } from '../../../../../store/workspace/thunks';
import { CheckSolidIcon, LayerIcon } from '../../../../../assets/icons';
import { thousandSeparator } from '../../../../../utils/numberHelpers';
import { useDispatch, useSelector } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';
import { useState } from 'react';
import {
    setPurchasePlanModal,
    setContactSalesModal,
    setChooseCreditCardModal,
    setSelectedPlanSeatCount,
} from '../../../../../store/workspace/slice';
import Input from '../../../../../components/Input';

export default function PurchasePlan() {
    const dispatch = useDispatch();
    const [count, setCount] = useState(0);
    const [showCounter, setShowCounter] = useState(false);
    // const isLoading = useSelector(selectRequestingChangePlan);
    const selectedPlan = useSelector(selectSelectedPricingPlan);
    const [referralCode, setReferralCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isReferralApplied, setIsReferralApplied] = useState(false);

    const finalPrice = selectedPlan ?
        (selectedPlan.finalPrice + (count * selectedPlan.seatBasePrice * selectedPlan.monthCount)) : 0;

    const confirmFunc = () => {
        dispatch(setSelectedPlanSeatCount(count));
        dispatch(setChooseCreditCardModal(true));
        dispatch(setPurchasePlanModal(false));
    };

    const updateCount = (mode: 'Decrement' | 'Increment') => {
        switch (mode) {
            case 'Decrement': {
                if (count !== 0) {
                    setCount(prev => prev - 1);
                }
                break;
            }
            case 'Increment': {
                if (count < 5) {
                    setCount(prev => prev + 1);
                }
                break;
            }
            default:
                return;
        }
    };

    const applyReferralCode = () => {
        setIsLoading(true);
        setErrorMessage('');
        dispatch(applyReferralCodeThunk({
            action: "get_payment_methods",
            promotion: referralCode
        }))
            .unwrap()
            .then(() => {
                setIsReferralApplied(true);
            })
            .catch(err => {
                setErrorMessage(err.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <Modal
            size='sm'
            icon={<LayerIcon />}
            title={`${selectedPlan?.name} Plan`}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setPurchasePlanModal(false))}
        >
            <div className={styles.content}>
                <div>
                    <b>{selectedPlan?.totalJobCount}</b> Jobs and &nbsp;
                    <b>{selectedPlan?.totalApplicantCount}</b> applicant / &nbsp;
                    {selectedPlan?.id.split('_')[1] === 'annual' ? 'yearly' : 'monthly'}
                </div>

                <div className={styles.detail}>
                    There is one owner account included in this plan.
                    To add more, an additional charge applies. &nbsp;
                    {!showCounter && <b onClick={() => setShowCounter(true)}>Add member</b>}
                </div>

                {showCounter && <div className={styles.seat}>
                    <div className={styles.seat_count}>
                        <b>{count}</b> Member account seat{count > 1 ? 's' : ''} ${count * (selectedPlan?.seatBasePrice || 0)} / mo.
                    </div>
                    <div className={styles.seat_action}>
                        <div
                            className={styles.seat_action_btn}
                            onClick={() => updateCount('Decrement')}
                            data-is-deactive={count === 0}
                        >
                            <span>-</span>
                        </div>
                        <span>{count}</span>
                        <div
                            className={styles.seat_action_btn}
                            onClick={() => updateCount('Increment')}
                            data-is-deactive={count === 5}
                        >
                            <span>+</span>
                        </div>
                    </div>
                </div>}

                {showCounter && count === 5 && <div className={styles.contact_sales}>
                    <span>For more than 5 seats please</span>
                    <b onClick={() => dispatch(setContactSalesModal(true))}>
                        contact sales
                    </b>
                </div>}

                <div className={styles.price}>
                    <span className={styles.price_discount}>
                        🎉 {selectedPlan?.id.split('_')[1] === 'annual' ? '%20 discount' : '7 Days Free Trial'}
                    </span>
                    <span className={styles.price_devider} />
                    <span className={styles.price_final}>
                        <b>${thousandSeparator(finalPrice)}</b> Final price
                    </span>
                </div>

                <div className={styles.referral}>
                    {isReferralApplied ?
                        <div className={styles.referral_applied}>
                            <CheckSolidIcon />
                            <span>Referral code applied</span>
                        </div> : <>
                            <Input
                                type='text'
                                maxLength={15}
                                label='Referral code'
                                value={referralCode}
                                hasError={!!errorMessage}
                                wrapperClassName={styles.referral_input}
                                onChange={(value: string) => setReferralCode(value.toUpperCase())}
                            />
                            <Button
                                type='Outline-Primary'
                                text='Apply'
                                loading={isLoading}
                                onClick={applyReferralCode}
                                disabled={!referralCode.trim()}
                                className={styles.referral_btn}
                            />
                        </>}
                </div>

                {errorMessage && <span className={styles.error}>{errorMessage}</span>}
            </div>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    disabled={isLoading}
                    className={styles.actions_btn}
                    onClick={() => dispatch(setPurchasePlanModal(false))}
                />
                <Button
                    type='Primary'
                    text='Continue'
                    disabled={isLoading}
                    onClick={confirmFunc}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
};
